var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"area-wrapper"},[_c('chooseAddress',{attrs:{"districtId":_vm.areaCode || '320102',"chooseIsShow":true},model:{value:(_vm.area),callback:function ($$v) {_vm.area=$$v},expression:"area"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }